import { EFeatureFlag } from "@frontend-shared/constants";

import { useFeatureFlag } from "@/hooks/use-feature-flag";

// NOTE: Gate semantics (NSAI-5286) —
//   `IS_ANONYMIZATION_LAB_ENABLED=true`    → show for everyone (no opt-in).
//   `IS_ANONYMIZATION_LAB_ENABLED_FF=true` → backend serves the lab endpoints,
//     but the sidebar item and route stay hidden until this browser opts in via
//     localStorage.enabled_anonymization_lab = "true". That is how the lab is
//     handed to a single tester on a channel where it is not public yet.
//   Otherwise → hidden.
// NSAI-1249 — the rule itself now lives in the shared registry
// (@frontend-shared/constants/feature-flags), so mobile resolves this flag
// identically; only the value comparison moved, the behaviour did not. Both
// server flags already fold in the deployment-wide PII kill switch, so a
// deployment whose chats do not mask reports both as false and no localStorage
// value can bring the lab back — the opt-in is an opt-IN, never an override.
// The backend guard mirrors this: it allows the API through when EITHER flag is
// true (see anonymization-lab-feature.guard.ts), so the localStorage opt-in path
// actually has an API to call. Reads from the public /app-config endpoint — no
// auth or permission required, mirroring useCallAssistantFeaturesEnabled.
export const useAnonymizationLabEnabled = (): boolean =>
  useFeatureFlag(EFeatureFlag.ANONYMIZATION_LAB);
